import React from 'react';

interface IHeaderProps {
  children: React.ReactNode;
}

export const Header: React.FC<IHeaderProps> = ({ children }: IHeaderProps) => {
  return <header className="header">{children}</header>;
};
